import {NavLink, useParams} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {config} from "../config";

export const IndexPageNavigation = () => {
    const { status } = useParams();
    
    let statusLabel = 'Messages';
    if (status === 'inbox') statusLabel = 'Inbox';
    else if (status === 'read') statusLabel = 'Read';
    else if (status === 'sent') statusLabel = 'Sent';
    else if (status === 'deleted') statusLabel = 'Deleted';

    const breadcrumbs = [
            {
                title: config.titles.plural,
                href: '/messages/status/inbox',
            },
            {
                title: statusLabel,
            }
        ].map((item, index) => (
            <Box key={index}> {
                item
                    .href ?
                    <NavLink to={item.href}>{item.title}</NavLink> : item.title
            }
            </Box>
        ))
    ;
    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

